/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.footer-logo {
  @apply w-[75px] h-[25px];
}


.footer-column { 
  @apply sm:min-w-[208px] md:min-w-[220px];
}

.footer-column h3.text-light-blue { 
  @apply mb-8px;
}

.footer-column .footer-link { 
  @apply max-w-[208px] w-fit;
}

.footer-body {
  @apply flex flex-row flex-wrap justify-between gap-32px pb-24px;
}

@media (min-width: 767px) and (max-width: 1070px) {
  .footer-body {
    @apply justify-start;
  }

  .footer-column {
    width: calc(34.3333% - 32px);
  }
}

@media (max-width: 766px) {
  .footer-column {
    width: calc(50% - 32px);
  }
}

.footer-link {
  @apply text-white transition-all w-fit relative py-8px;
}

.footer-link:after {
  @apply block absolute w-full h-2px bg-light-blue bottom-0 left-0 opacity-0;
  content: '';
  transform: scaleX(0);
  transition: transform 0.3s, opacity 0.3s;
}

.footer-link:hover:after {
  @apply opacity-100 ;
  transform:scaleX(1);
}

.instagram {
  @apply flex justify-start items-center gap-12px;
}
.instagram:before {
  @apply block w-16px h-16px;
  content:'';
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;
  background-color: white;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/nav-icons/social-instagram.svg');
}

.facebook {
  @apply flex justify-start items-center gap-12px;
}

.facebook:before {
  @apply block w-16px h-16px;
  content:'';
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;
  background-color: white;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/nav-icons/social-facebook.svg');
}

.twitter {
  @apply flex justify-start items-center gap-12px;
}

.twitter:before {
  @apply block w-16px h-16px;
  content:'';
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;
  background-color: white;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/nav-icons/social-twitter.svg');
}

.linkedin {
  @apply flex justify-start items-center gap-12px;
}

.linkedin:before {
  @apply block w-16px h-16px;
  content:'';
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;
  background-color: white;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/nav-icons/social-linkedin.svg');
}

.youtube {
  @apply flex justify-start items-center gap-12px;
}

.youtube:before {
  @apply block w-16px h-16px;
  content:'';
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;
  background-color: white;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/nav-icons/social-youtube.svg');
}

.newsletter {
  @apply flex justify-start items-center gap-12px;
}
.newsletter:before {
  @apply block w-16px h-16px;
  content:'';
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;
  background-color: white;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/nav-icons/social-newsletter.svg');
}